import Vue from 'vue/dist/vue.min.js';
import EventBus from './event-bus';

export const Checkbox = {
    props: ['data', 'label', 'value', 'type', 'category'],
    data: function() {
        return {
            id: null,
            isChecked: false,
        }
    },
    // template for product checkboxes only
    // static checkboxes are inline templates 
    template: `
        <div class="checkbox">
            <label class="checkbox__label">
                <input type="checkbox" class="checkbox__input" ref="input" v-on:change="updateFilters(data.class, $event, type)" 
                :value="value" 
                :checked="isChecked" 
                data-tag-trigger="click" 
                :data-tag-meta="taggingMeta">
                <span class="checkbox__checkmark"></span>
                <span class="checkbox__label-text" v-html="label"></span>
            </label>
        </div>
    `,
    watch: {
        "data.filters": function() {
            this.checkState();
        },
        "data.products": function() {
            this.checkProductState();
        }
    },
    computed: {
        taggingMeta: function() {
            return JSON.stringify({
                "type": this.data.trackingType, 
                "action": this.category || null, 
                "label": decodeURIComponent(this.id)
            })
        }
    },
    methods: {
        updateFilters(el, e, type) {
            EventBus.$emit('updateFilters', el, e, type);
        },
        checkState() {
            let item = this.data.filters.find(el => {
                return el.value == this.id;
            });
            this.isChecked = item ? true : false;
        },
        checkProductState() {
            if (this.type === "product") {
                // console.log("is product");
                let item = this.data.filters.find(el => {
                    // console.log("el", el.value);
                    // console.log("id", this.id);
                    return el.value == this.id;
                });
                this.isChecked = item ? true : false;
                // console.log(this.isChecked);
            }
        }
    },
    mounted() {
        this.id = encodeURIComponent(this.$refs.input.value);
        // this.category = null;
        this.checkState();
        // if has saved docs filter, get the label
        if (this.$refs.input.dataset.savedLabel) {
            this.data.savedDocsLabel = this.$refs.input.dataset.savedLabel;
        }
    }
};

export const Accordion = {
    props: ['data', 'defaultopen'],
    components: {
        'checkbox-item': Checkbox
    },      
    data: function() {
        return {
            isOpen: (this.defaultopen ? true : false), //is the accordion open
            isTruncated: null, //is accordion content truncated 
            openText: null,
            closeText: null,
            seeAllTypesText: false
        }
    },
    watch: {
        isTruncated: function() {
            if (this.isTruncated == true) {
                this.openText = this.$refs.expandText.dataset.expandText;
                this.closeText = this.$refs.expandText.dataset.collapseText;
            }
        },
        "data.products": {
            deep: true,
            handler() {
                this.$nextTick(() => {
                    /*
                    this.isTruncated = this.data.products.length > 0 ? this.isTruncated : null;
                    if (this.$el.querySelector('.checkbox:nth-of-type(6)')) {
                        this.toggleTruncation(true);
                    } else {
                        this.isTruncated = null;
                    }
                    */
                });    
            }
        }
    },
    methods: {
        handleClick() {
            this.toggleAccordion();
        },

        toggleAccordion() {
            let contentArea = this.$refs.outerContainer;
            let contentHeight = this.$refs.innerContainer.getBoundingClientRect().height;

            if (this.isOpen == true) {
                this.isOpen = false;

                requestAnimationFrame(function() {
                    //set content area height to content height to prevent transitioning from auto
                    contentArea.style.maxHeight = contentHeight + 'px';
                    // have the element transition to height: 0
                    requestAnimationFrame(function() {
                        contentArea.style.maxHeight = '0px';
                    });
                });

                contentArea.addEventListener('transitionend', () => {
                    contentArea.style.maxHeight = '0';
                });

            } else {
                this.isOpen = true;
                contentArea.style.maxHeight = contentHeight + "px";
                contentArea.addEventListener('transitionend', () => {
                    contentArea.style.maxHeight = 'none';
                });
            }
        },
        toggleSeeAll() {
            this.seeAllTypesText = !this.seeAllTypesText
        },
        toggleTruncation(state) {
            return;
            // console.log("truncate this");
            if (state) {
                this.isTruncated = state;
            } else {
                this.isTruncated = this.isTruncated == null ? true : !this.isTruncated;
            }

            var truncHeight = 0;
            let container = this.$refs.innerContainer;

            const truncate = () => {
                for (let i = 1; i < 6; i++) {
                    let el = this.$el.querySelector(`.checkbox:nth-of-type(${i})`);
                    let itemHeight = el.getBoundingClientRect().height;
                    let elStyles = window.getComputedStyle(el);
                    let itemMargin = parseFloat(elStyles.marginBottom);

                    truncHeight = truncHeight + itemHeight + itemMargin;
                }
                truncHeight = truncHeight + 5; //little bit of wiggleroom
            }

            truncate();

            if (this.isTruncated == true) {
                container.style.maxHeight = truncHeight + "px";
            } else {
                container.style.maxHeight = 'none';
            }
        },
    },
    mounted() {
      
    }
};

export const SelectedFiltersComponent = {
    props: ['data'],
    data: function() {
        return {
        }
    },
    computed: {
        className: function() {
            return `${this.data.class}__selected-filters`;
        } 
    },
    template: `
        <div :class="className" :data="data">
            <div class="filter-label" v-for="filter in data.filters" :key="filter.value" :data-value="filter.value" :data-type="filter.type" v-on:click="removeFilter($event)">
                <div class="filter-label__wrapper">
                    <span class="filter-label__icon"></span>
                    <span class="filter-label__text">{{filter.name}}</span>
                </div>
            </div>
        </div>
    `,
    methods: {
        removeFilter(e) {
            let type = e.currentTarget.dataset.type;
            let value = e.currentTarget.dataset.value;
            EventBus.$emit('remove-filter', this.data.class, value, type);
        }
    },
    mounted() {
        
    }
};

export const PageNum = {
    props: ['data', 'num'],
    data: function() {
        return {
            page: null,
            isActive: false,
            isSpacer: false
        }
    },
    watch: {
        "data.currentPage": function() {
            this.isActive = this.data.currentPage == this.num ? true : false;
        }
    },
    template: `
        <span :class="{active: isActive}" v-on:click="changePageTo(num)">{{num}}</span>
    `,
    methods: {
        changePageTo(num) {
            if(num !== "...") {
                EventBus.$emit('change-page-to', this.data.class, num);
                EventBus.$emit('scroll-to-top', this.data.class);
            } else {
                return;
            }
        },
    },
    mounted() {
        this.isActive = this.data.currentPage == this.num ? true : false;
    }
};

export const Pagination = {
    props: ['data'],
    data: function() {
        return {
            pageNums: [],
        }
    },
    computed: {
        className: function() {
            return `${this.data.class}__pagination-nums`;
        }
    },  
    components: {
        'page-num': PageNum
    },
    watch: {
        "data.currentPage": function() {
            this.pageNums = [];
            this.initPages();
            if (this.data.currentPage > this.data.totalPages) {
                EventBus.$emit('change-page-to', this.data.class, 1);
            }
        },
        "data.totalPages": function() {
            this.pageNums = [];
            this.initPages();
            EventBus.$emit('change-page-to', this.data.class, 1);
        }
    },
    template: `
    <div :class="className">
        <page-num v-for="(num, index) in pageNums" :num="num" :data="data" :key="index"/>
    </div>
    `,
    methods: {
        initPages() {
            if (this.data.totalPages <= 6) {
                // if less than 6 pages, list all pages
                for(let page = 1; page < this.data.totalPages + 1; page++) {
                    this.pageNums.push(page);
                }
            } else {
                if(this.data.currentPage > this.data.totalPages - 6) {
                    // on the last 6 pages, do not add ellipsis
                    for(let page = this.data.totalPages - 5; page < this.data.currentPage + 6 && page < this.data.totalPages + 1; page++) {
                        this.pageNums.push(page);
                        // console.log(page);
                    }                            
                } else {
                    // if not on the last 6 pages, add ellpisis
                    for(let page = this.data.currentPage; page < this.data.currentPage + 3 && page < this.data.totalPages - 1; page++) {
                        this.pageNums.push(page);
                    }
                    this.pageNums.push("...");
                    for(let page = this.data.totalPages - 1; page < this.data.totalPages + 1; page++) {
                        this.pageNums.push(page);
                    }
                }
            }
        }
    },
    mounted() {
        this.initPages();
    }
};
